import React, { useEffect, useState } from 'react'
import styles from './style/creation-item.module.less'
import Face from '../../assets/imgs/chat-face2.svg'
import {
  IconClosure,
  IconDownload,
  IconCollect,
  IconCollectFill,
  IconBaseSync,
  IconErrorTip,
  IconSuccessTip,
} from '@arco-iconbox/react-aidb-v2'
import ModalCustom from '../../components/ModalCustom'
import { Input, Message, Popconfirm, Tooltip } from '@arco-design/web-react'
import BorderBtn from '../../components/BorderBtn'
import ImageDetailPop from './ImageDetailPop'
import {
  aiImgAgain,
  aiImgCancelCoolect,
  aiImgCoolect,
  aiImgGetCoolectList,
  aiImgSimpleChange,
} from '@/model/reference'

const TextArea = Input.TextArea

function CreationItem(props) {
  const {
    bigImg,
    close,
    desc,
    type,
    id,
    baseUrl,
    date,
    OnSimpleChange,
    sendSuccess,
    OnhandleAgain,
    updateScroolTop,
    onUpdateCollect,
    collect,
    typePath,
    aspect,
    downloadImg,
  } = props
  //图片下按钮
  const btn_group1 = [
    {
      title: 'U1',
    },
    {
      title: 'U2',
    },
    {
      title: 'U3',
    },
    {
      title: 'U4',
    },
  ]
  const btn_group2 = [
    {
      title: 'V1',
    },
    {
      title: 'V2',
    },
    {
      title: 'V3',
    },
    {
      title: 'V4',
    },
  ]
  //u1状态
  const [curBtn, setCurBtn] = React.useState('U0')
  //v1状态
  const [vurBtn, setVurBtn] = useState('V0')
  //二次编辑弹窗
  const [visible, setVisible] = React.useState(false)
  //是否收藏
  const [isCollect, setIsCollect] = React.useState(collect)
  //详情弹窗
  const [visibleDet, setVisibleDet] = React.useState(false)
  //弹窗中输入框的值
  const [txtValue, setTxtValue] = useState(desc)
  useEffect(() => {
    setTxtValue(desc)
  }, [desc])

  useEffect(() => {
    setIsCollect(collect)
  }, [collect])
  //生成单张大图U
  function handleUIndex(item) {
    aiImgSimpleChange({
      content: id + ' ' + item.title,
      notifyHook: '',
      state: txtValue,
    })
      .then((res) => {
        console.log(res.data)

        if (res.data.success == true) {
          console.log(res.data.data)

          if (res.data.data?.description == '任务已存在') {
            Message.error({
              icon: <IconErrorTip useCurrentColor={false} />,
              content: '图片已存在',
            })
            console.log('qqqq')
          } else {
            updateScroolTop()
            OnSimpleChange(res.data.data.result, 2, txtValue)
            console.log('dd')
          }
        } else {
          Message.error({
            icon: <IconErrorTip useCurrentColor={false} />,
            content: res.data.msg,
          })
        }
      })
      .catch((error) => {
        Message.error({
          icon: <IconErrorTip useCurrentColor={false} />,
          content: '请求数据错误，请重新尝试',
        })
      })
    setCurBtn(item.title)
  }

  //重新生成单张V
  function handleVIndex(item) {
    aiImgSimpleChange({
      content: id + ' ' + item.title,
      notifyHook: '',
      state: txtValue,
    })
      .then((res) => {
        console.log(res.data)
        if (res.data.success == true) {
          updateScroolTop()
          if (typePath == 'Synthesis') {
            OnSimpleChange(res.data.data.result, 1, baseUrl)
          } else {
            OnSimpleChange(res.data.data.result, 1, txtValue)
          }
        } else {
          Message.error({
            icon: <IconErrorTip useCurrentColor={false} />,
            content: res.data.msg,
          })
        }
      })
      .catch((error) => {
        console.log(error.response)

        Message.error({
          icon: <IconErrorTip useCurrentColor={false} />,
          content: error.response,
        })
        setVisible(false)
      })
  }

  //下载图片
  function handleDownLoad() {
    fetch(downloadImg)
      .then((response) => response.blob())
      .then((blob) => {
        // 创建一个Blob URL
        const blobUrl = URL.createObjectURL(blob)

        // 创建一个<a>元素用于下载
        const a = document.createElement('a')
        a.href = blobUrl
        a.download = 'ai创作图片' // 设置要下载的文件名

        // 模拟点击<a>元素以触发下载
        a.click()

        // 释放Blob URL资源
        URL.revokeObjectURL(blobUrl)
      })
  }

  //重新生成
  async function fetchImage() {
    if (baseUrl == '' || baseUrl == null || baseUrl == undefined) {
      if (typePath == 'Synthesis') {
        OnhandleAgain('', aspect)
      } else {
        OnhandleAgain('', desc)
      }
    } else {
      try {
        if (typePath == 'Synthesis') {
          const promises = baseUrl.map(async (url) => {
            const response = await fetch(url)
            const blob = await response.blob()
            const reader = new FileReader()

            return new Promise((resolve, reject) => {
              reader.onload = () => {
                const base64Data = reader.result
                resolve(base64Data)
              }
              reader.onerror = (error) => {
                console.error('Error reading image:', error)
                reject(error)
              }
              reader.readAsDataURL(blob)
            })
          })

          const base64Images = await Promise.all(promises)
          OnhandleAgain(base64Images, aspect, baseUrl)
        } else {
          const response = await fetch(baseUrl)
          const blob = await response.blob()
          const reader = new FileReader()

          reader.onload = () => {
            const base64Data = reader.result
            console.log(base64Data)
            OnhandleAgain(base64Data, desc)
          }
          reader.readAsDataURL(blob)
        }
      } catch (error) {
        console.error('Error fetching or converting image:', error)
      }
    }
  }
  console.log(bigImg.slice(0, 26))

  //收藏图片
  function handleCollect() {
    aiImgCoolect({
      state: txtValue,
      imageUrl: bigImg,
      imageId: id,
      type: typePath == 'Synthesis' ? 'Synthesis' : 'aiDrawing',
    })
      .then((res) => {
        if (res.data.success == true) {
          Message.success({
            icon: <IconSuccessTip useCurrentColor={false} />,
            content: '收藏图片成功',
          })
          setIsCollect(true)
          onUpdateCollect(true, id)
        } else {
          Message.error({
            icon: <IconErrorTip useCurrentColor={false} />,
            content: res.data.msg,
          })
        }
      })
      .catch((error) => {
        console.log(error.response)

        Message.error({
          icon: <IconErrorTip useCurrentColor={false} />,
          content: error.response,
        })
        setVisible(false)
      })
  }

  //取消收藏图片
  function handleCancelCollect() {
    aiImgCancelCoolect({
      imageId: [id],
    })
      .then((res) => {
        if (res.data.success == true) {
          Message.success({
            icon: <IconSuccessTip useCurrentColor={false} />,
            content: '取消收藏图片成功',
          })
          setIsCollect(false)
          onUpdateCollect(false, id)
        } else {
          Message.error({
            icon: <IconErrorTip useCurrentColor={false} />,
            content: res.data.msg,
          })
        }
      })
      .catch((error) => {
        console.log(error.response)

        Message.error({
          icon: <IconErrorTip useCurrentColor={false} />,
          content: error.response,
        })
        setVisible(false)
      })
  }

  return (
    <div>
      <div className={styles.item}>
        <div className={styles.title}>
          <div className={styles.left}>
            <div className={styles.face}>
              <Face />
            </div>
            <div className={styles.name}>智能机器人</div>
            <div className={styles.date}>{date}</div>
          </div>
          {bigImg?.slice(0, 26) == 'https://mirror-hk.v-dk.com' ? (
            <Popconfirm
              position="bottom"
              focusLock
              title="确定要删除吗？"
              onOk={() => {
                close()
              }}>
              <div className={styles.close}>
                <IconClosure />
              </div>
            </Popconfirm>
          ) : (
            <Tooltip position="top" trigger="hover" content={'努力绘图中...'}>
              <div className={styles.imgLoading}>
                <IconBaseSync />
              </div>
            </Tooltip>
          )}
        </div>
        <div className={styles.content}>
          {/* <div className={styles.link}>
          <a href={link} rel="noreferrer" target="_blank">
            {link}
          </a>
        </div> */}
          {desc?.length > 0 && (
            <div className={styles.desc}>AI 想象提示：{desc}</div>
          )}
          {type === 1 && (
            <>
              <div
                className={styles.big_img}
                onClick={() => {
                  setVisibleDet(true)
                }}>
                <div
                  className={styles.btns}
                  onClick={(e) => {
                    handleDownLoad()
                    e.stopPropagation()
                  }}>
                  <div className={`${styles.download} ${styles.icon}`}>
                    <IconDownload />
                  </div>
                  <div className={styles.icon}>
                    {isCollect ? (
                      <IconCollectFill
                        onClick={(e) => {
                          handleCancelCollect()
                          e.stopPropagation()
                        }}
                      />
                    ) : (
                      <IconCollect
                        onClick={(e) => {
                          handleCollect()
                          e.stopPropagation()
                        }}
                      />
                    )}
                  </div>
                </div>
                <img src={bigImg} alt="" />
              </div>
              <div className={styles.btn_group}>
                <div className={styles.btn_row}>
                  {btn_group1.map((item, index) => {
                    return (
                      <div
                        className={` ${!sendSuccess ? styles.UVdisable : ''} ${
                          styles.btn
                        }`}
                        key={index}
                        onClick={() => {
                          handleUIndex(item)
                        }}>
                        {item.title}
                      </div>
                    )
                  })}
                </div>
                <div className={styles.btn_row}>
                  {btn_group2.map((item, index) => {
                    return (
                      <div
                        className={` ${!sendSuccess ? styles.UVdisable : ''} ${
                          styles.btn
                        }`}
                        key={index}
                        onClick={() => {
                          // setVurBtn(item.title)
                          handleVIndex(item)
                        }}>
                        {item.title}
                      </div>
                    )
                  })}
                </div>
              </div>
            </>
          )}
          {type === 2 && (
            <div
              className={styles.big_img}
              onClick={() => {
                setVisibleDet(true)
              }}>
              <div className={styles.btns}>
                <div
                  className={`${styles.download} ${styles.icon}`}
                  onClick={(e) => {
                    handleDownLoad()
                    e.stopPropagation()
                  }}>
                  <IconDownload />
                </div>
                <div className={styles.icon}>
                  {isCollect ? (
                    <IconCollectFill
                      onClick={(e) => {
                        handleCancelCollect()
                        e.stopPropagation()
                      }}
                    />
                  ) : (
                    <IconCollect
                      onClick={(e) => {
                        handleCollect()
                        e.stopPropagation()
                      }}
                    />
                  )}
                </div>
              </div>
              <img src={bigImg} alt="" />
            </div>
          )}
        </div>
        {sendSuccess && type == 1 && (
          <div className={styles.ref} onClick={fetchImage}>
            <IconBaseSync />
          </div>
        )}
        {/* <ModalCustom
        black={true}
        titleHeight={true}
        width={'485px'}
        title={'AI图片创作'}
        visible={visible}
        close={() => setVisible(false)}
        content={EditPopInner}
      /> */}
        <ModalCustom
          black={true}
          width={'1280px'}
          title={null}
          visible={visibleDet}
          close={() => setVisibleDet(false)}
          content={
            <ImageDetailPop
              type={2}
              desc={desc}
              bigImg={bigImg}
              collect={collect}
              OnhandleCollect={handleCollect}
              OnhandleCancelCollect={handleCancelCollect}
              onhandleDownLoad={handleDownLoad}
            />
          }
        />
      </div>
    </div>
  )
}

export default CreationItem
